import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HelpSearchItem } from './help-search.model';

@Injectable({
  providedIn: 'root'
})
export class HelpSearchService {
  searchText$ = new BehaviorSubject<string>('');

  private searchItems: HelpSearchItem[] = [

    // Copyright
    {
      title: 'Copyright',
      route: '/helpfile/copyright',
      sectionId: 'copyright'
    },

    // Licence
    {
      title: 'Licence',
      route: '/helpfile/licence',
      sectionId: 'licence'
    },

    // Introduction
    {
      title: 'Introduction',
      route: '/helpfile/introduction',
      sectionId: 'introduction'
    },

    // Quick Reference
    {
      title: 'Quick Reference',
      route: '/helpfile/Quickreference',
      sectionId: 'creatingpasswordandLoggingin'
    },

    // Charities
    {
      title: 'Create Charity',
      route: '/helpfile/Charities',
      sectionId: 'createcharity'
    },
    {
      title: 'Search Charity',
      route: '/helpfile/Charities',
      sectionId: 'searchcharity'
    },
    {
      title: 'View Charity',
      route: '/helpfile/Charities',
      sectionId: 'view-charity'
    },
    {
      title: 'Charity Overview',
      route: '/helpfile/Charities',
      sectionId: 'charity-overview'
    },
    {
      title: 'Edit Charity',
      route: '/helpfile/Charities',
      sectionId: 'edit-charity'
    },
    {
      title: 'Delete Charity',
      route: '/helpfile/Charities',
      sectionId: 'delete-charity'
    },

    // Accounting Period
    {
      title: 'Open Accounting Period',
      route: '/helpfile/accounting-period',
      sectionId: 'openaccountingperiod'
    },
    {
      title: 'Trial Balance',
      route: '/helpfile/accounting-period',
      sectionId: 'trialBalanceToggle'
    },
    {
      title: 'Import Trial Balance',
      route: '/helpfile/accounting-period',
      sectionId: 'import-trial-balance'
    },
    {
      title: 'Companies House',
      route: '/helpfile/accounting-period',
      sectionId: 'companyhouse'
    },

    // Reports
    {
      title: 'Reports',
      route: '/helpfile/reportsguidedataset',
      sectionId: 'reports'
    },
    {
      title: 'Print',
      route: '/helpfile/reportsguidedataset',
      sectionId: 'printreport'
    },
    {
      title: 'Export As',
      route: '/helpfile/reportsguidedataset',
      sectionId: 'exportas'
    },

    // Submission History
    {
      title: 'Submission History',
      route: '/helpfile/submissionhistorysdata',
      sectionId: 'submissionhistorysdata'
    },
    {
      title: 'Search Submissions',
      route: '/helpfile/submissionhistorysdata',
      sectionId: 'search-submissions'
    },

    // Settings
    {
      title: 'Settings',
      route: '/helpfile/settingshelp',
      sectionId: 'settings'
    },
    {
      title: 'Email Configuration',
      route: '/helpfile/settingshelp',
      sectionId: 'email-configuration'
    },
    {
      title: 'User Management',
      route: '/helpfile/settingshelp',
      sectionId: 'user-management'
    }
  ];

  search(term: string): HelpSearchItem[] {

    if (!term.trim()) {
      return [];
    }

    return this.searchItems.filter(item =>
      item.title.toLowerCase().includes(
        term.toLowerCase()
      )
    );
  }
}
